import React, { useState } from 'react';
import { Platform } from '@/types';

interface PlatformSelectorProps {
    platform: Platform;
    onSelect: (platform: Platform) => void;
}

export const PlatformSelector: React.FC<PlatformSelectorProps> = ({ platform, onSelect }) => {
    const [activeTooltip, setActiveTooltip] = useState<string | null>(null);

    const handleDisabledClick = (name: string) => {
        setActiveTooltip(name);
        setTimeout(() => setActiveTooltip(null), 2000);
    };

    return (
        <div className="flex flex-wrap gap-4 mb-8 justify-center">

            {/* Mercado Livre (Active) */}
            <button
                type="button"
                onClick={() => onSelect('mercadolivre')}
                className={`flex items-center gap-2 px-5 py-3 rounded-2xl transition-all border-2 shadow-sm ${platform === 'mercadolivre'
                    ? 'bg-yellow-100/50 dark:bg-yellow-900/20 border-yellow-400 text-yellow-700 dark:text-yellow-400 ring-2 ring-yellow-400/20'
                    : 'border-transparent opacity-50 hover:opacity-100 hover:bg-gray-50 dark:hover:bg-gray-800'
                    }`}
            >
                <span className={`w-2 h-2 rounded-full ${platform === 'mercadolivre' ? 'bg-yellow-400 animate-pulse' : 'bg-gray-400'}`}></span>
                <span className="text-xs font-bold uppercase tracking-wide">Mercado Livre</span>
            </button>

            {/* Amazon (Disabled) */}
            <button
                type="button"
                onClick={() => handleDisabledClick('amazon')}
                className={`relative flex items-center gap-2 px-5 py-3 rounded-2xl transition-all border-2 shadow-sm ${platform === 'amazon'
                    ? 'bg-gray-800 dark:bg-black/40 border-gray-600 dark:border-gray-500 text-white dark:text-white ring-2 ring-gray-500/20'
                    : 'border-transparent opacity-50 hover:bg-gray-50 dark:hover:bg-gray-800'
                    }`}
            >
                <span className={`w-2 h-2 rounded-full ${platform === 'amazon' ? 'bg-white dark:bg-white animate-pulse' : 'bg-gray-400'}`}></span>
                <span className="text-xs font-bold uppercase tracking-wide">Amazon</span>

                {activeTooltip === 'amazon' && (
                    <div className="absolute -top-11 left-1/2 -translate-x-1/2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-xs font-semibold whitespace-nowrap rounded-lg shadow-xl animate-in fade-in zoom-in slide-in-from-bottom-2 pointer-events-none z-10">
                        Plataforma desativada no momento.
                        <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 dark:bg-gray-700 rotate-45 rounded-[1px]"></div>
                    </div>
                )}
            </button>

            {/* Shopee (Active) */}
            <button
                type="button"
                onClick={() => onSelect('shopee')}
                className={`flex items-center gap-2 px-5 py-3 rounded-2xl transition-all border-2 shadow-sm ${platform === 'shopee'
                    ? 'bg-orange-100/50 dark:bg-orange-900/20 border-orange-500 text-orange-600 dark:text-orange-400 ring-2 ring-orange-500/20'
                    : 'border-transparent opacity-50 hover:opacity-100 hover:bg-gray-50 dark:hover:bg-gray-800'
                    }`}
            >
                <span className={`w-2 h-2 rounded-full ${platform === 'shopee' ? 'bg-orange-500 animate-pulse' : 'bg-gray-400'}`}></span>
                <span className="text-xs font-bold uppercase tracking-wide">Shopee</span>
            </button>

            {/* Magalu (Active) */}
            <button
                type="button"
                onClick={() => onSelect('magalu')}
                className={`flex items-center gap-2 px-5 py-3 rounded-2xl transition-all border-2 shadow-sm ${platform === 'magalu'
                    ? 'bg-blue-100/50 dark:bg-blue-900/20 border-blue-500 text-blue-600 dark:text-blue-400 ring-2 ring-blue-500/20'
                    : 'border-transparent opacity-50 hover:opacity-100 hover:bg-gray-50 dark:hover:bg-gray-800'
                    }`}
            >
                <span className={`w-2 h-2 rounded-full ${platform === 'magalu' ? 'bg-blue-500 animate-pulse' : 'bg-gray-400'}`}></span>
                <span className="text-xs font-bold uppercase tracking-wide">Magalu</span>
            </button>

            {/* AliExpress (Active) */}
            <button
                type="button"
                onClick={() => onSelect('aliexpress')}
                className={`flex items-center gap-2 px-5 py-3 rounded-2xl transition-all border-2 shadow-sm ${platform === 'aliexpress'
                    ? 'bg-red-100/50 dark:bg-red-900/20 border-red-500 text-red-600 dark:text-red-400 ring-2 ring-red-500/20'
                    : 'border-transparent opacity-50 hover:opacity-100 hover:bg-gray-50 dark:hover:bg-gray-800'
                    }`}
            >
                <span className={`w-2 h-2 rounded-full ${platform === 'aliexpress' ? 'bg-red-500 animate-pulse' : 'bg-gray-400'}`}></span>
                <span className="text-xs font-bold uppercase tracking-wide">AliExpress</span>
            </button>
        </div>
    );
};
